module.exports = __webpack_public_path__ + "img/eb3d8f8.png";